import { Avatar, getCat, fmt } from '../lib/helpers';

export function FriendsPage({ people, balances, meId }) {
  const others = people.filter(p => p.id !== meId);
  return (
    <div className="content">
      <div className="expense-list">
        {others.map(p => {
          // net[meId][p.id] > 0 means I owe p
          const v = balances.net?.[meId]?.[p.id] || 0;
          return (
            <div className="expense-row" key={p.id} style={{ cursor: 'default' }}>
              <Avatar person={p} size={38} />
              <div className="exp-info">
                <div className="exp-name">{p.name}</div>
                <div className="exp-meta">friend</div>
              </div>
              <div className="exp-right">
                {Math.abs(v) > 0.01 ? (
                  <div className={`exp-share ${v > 0 ? 'text-red' : 'text-green'}`} style={{ fontSize: 14, fontWeight: 600 }}>
                    {v > 0 ? `you owe ${fmt(v)}` : `owes you ${fmt(v)}`}
                  </div>
                ) : (
                  <div className="exp-share text-muted">settled up</div>
                )}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export function ActivityPage({ expenses, people, groups }) {
  const personById = (id) => people.find(p => p.id === id);
  const sorted = [...expenses].sort((a, b) => new Date(b.date) - new Date(a.date));
  return (
    <div className="content">
      <div className="expense-list">
        {sorted.length === 0 && <div className="empty">No activity yet.</div>}
        {sorted.map(exp => {
          const cat = getCat(exp.category);
          const payer = personById(exp.paid_by);
          const group = groups.find(g => g.id === exp.group_id);
          return (
            <div className="expense-row" key={exp.id} style={{ cursor: 'default' }}>
              <div className="exp-icon" style={{ background: group ? group.color + '22' : '#eee', color: group?.color }}>
                {cat.icon}
              </div>
              <div className="exp-info">
                <div className="exp-name">{exp.name}</div>
                <div className="exp-meta">{payer?.name} paid · {exp.date} · {group?.name}</div>
              </div>
              <div className="exp-right">
                <div className="exp-total">{fmt(exp.amount)}</div>
                <div className="exp-share text-muted">{exp.split.length} people</div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
